import request from 'sb-request'
import { sentry, constants, sleep, mixpanel } from 'common/helpers'


// if subscription/progress doest not return { status: 'str' }
// then method will return subscription/commit response format (success or error)
const subscriptionProcessing = (body) => (
  request.post('rest/subscription/progress', { body, withErrorModal: false })
)

/**
 *
 * @param {object} body
 * @param {string} body.subscriptionSession
 * @returns {*}
 */
const recursionSubscriptionProcessing = async (body) => {
  const result = await subscriptionProcessing(body)

  // if status 'progress' then need check this status until the data or error returns.
  if (result && result.status === constants.subscriptionProcessingStatuses.progress) {
    await sleep(2000) // every 2 sec
    return recursionSubscriptionProcessing(body)
  }

  mixpanel.track(constants.analyticsEvents.tech.recursionSubscriptionProcessing.done)

  // if status 'new' - then this big error in backend side
  if (result && result.status === constants.subscriptionProcessingStatuses.new) {
    const error = 'Fail rest/subscription/progress! Method returned { status: "NEW" }'
    sentry.captureException(error)

    // data for error modal
    return {
      error,
      title: 'Something went wrong',
      message: 'We`re having technical issues at that moment. Please try again later.',
    }
  }

  // if subscription/progress is crashed
  if (result && result.error) {
    return Promise.reject(result)
  }

  // return success data or error (subscription/commit format)
  return result
}


export default recursionSubscriptionProcessing
